import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker'
import logout from '../../Global/logout' 

export default async function CreateClientType(
    client_type_name,
    countryUuid
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/client/type?countryUuid=' + countryUuid, {
            method: 'post',
            headers: { 
                'Authorization' : unHashedJwt                 
            },
            data: {
                "client_type_name": client_type_name.trim()
            }      
        }).then(res => res)
        .catch(error => error.response.data)
        );
}